import clsx from 'clsx'
import React from 'react'

export const Spinner: React.FC<React.ComponentProps<'svg'> & { color?: string }> = ({ className, color, ...props }) => {
  return (
    <svg className={clsx(className, 'size-5 animate-spin')} viewBox="0 0 24 24" data-slot="icon" {...props}>
      <circle
        className="opacity-50"
        cx="12"
        cy="12"
        r="10"
        stroke={color ?? 'currentColor'}
        fill="none"
        strokeWidth="4"
      ></circle>
      <path
        className="opacity-100"
        fill={color ?? 'currentColor'}
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  )
}
